import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import axios from "axios";
import { exportMonthlyReportToExcel } from "../../utils/exportToExcel"; // update path as needed
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";
import "./Report.css";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "center" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0", textAlign: "center" };

const MonthlyReport = () => {
  const { year, month } = useParams();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;
  const formattedMonthYear = `${new Date(year, month - 1).toLocaleString(
    "default",
    {
      month: "long",
    }
  )} - ${year}`;

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);

      try {
        const config = Authorization();
        const { data } = await axios.get(
          `${Api}/api/reports/monthly-loan-report?year=${year}&month=${month}`,
          config
        );
        setReportData(data);
      } catch (err) {
        console.error("Failed to fetch report", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [year, month]);



  if (!reportData)
    return <p className="text-danger mt-4">No report data found.</p>;

  return (

    <div className="mt-4">
      {loading && <Preloader loading={loading} />}
      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            <h4 className="mb-3 text-center">
              Monthly Progress Report Stating Recovery Of Loan For the Month of{" "}
              {formattedMonthYear}
            </h4>
            <div className="text-end mb-2">
              <button
                type="button"
                className="btn btn-outline-success btn-icon-text mt-3"
                onClick={() =>
                  exportMonthlyReportToExcel(
                    reportData,
                    formattedMonthYear,
                    year
                  )
                }
              >
                <i className="mdi mdi-file-excel"></i> Export to Excel
              </button>
            </div>
            <div style={{ padding: 16, overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead className="text-center align-middle">
                  <tr style={thStyle}>
                    <th className="wrap-header px-4 border-start" rowSpan={2}>
                      Sl. No.
                    </th>
                    <th className="wrap-header px-4 border-start" rowSpan={2}>
                      Division
                    </th>
                    <th className="wrap-header px-4 border-start" colSpan={7}>
                      Department Loan
                    </th>
                    <th className="wrap-header px-4 border-start" colSpan={7}>
                      Revolving Fund
                    </th>
                  </tr>
                  <tr style={thStyle}>
                    <th className="wrap-header px-4 border-start">
                      No. of <br /> TAP Villages
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Year of <br /> Disbursement of Loan
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Total Amount <br /> of Loan Disbursed
                    </th>
                    <th className="wrap-header px-4 border-start">
                      No. of <br /> Beneficiaries
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> up to Previous Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> During the Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> up to End of Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      % of <br /> Loan Recovered
                    </th>

                    <th className="wrap-header px-4 border-start">
                      Total Amount <br /> of Loan Given <br /> from Revolving
                      Fund
                    </th>
                    <th className="wrap-header px-4 border-start">
                      No. of <br /> Beneficiaries
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> up to Previous Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> During the Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      Amount Recovered <br /> up to End of Month
                    </th>
                    <th className="wrap-header px-4 border-start">
                      % of <br /> Loan Recovered
                    </th>
                    <th className="wrap-header px-4 border-start">
                      % of <br /> Revolving Loan Given
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {reportData
                    ?.sort((a, b) => a.division.localeCompare(b.division))
                    .map((row, idx) => (
                      <tr key={idx} style={tdStyle}>
                        <td>{idx + 1}.</td>
                        <td>{row.division}</td>
                        <td>{row.tapVillages}</td>
                        <td className="text-center">{row.financialYear}</td>
                        <td>{row.deptLoanAmount.toLocaleString("en-IN")}</td>
                        <td>{row.deptBeneficiaries.toLocaleString("en-IN")}</td>
                        <td>{row.deptRecoveredPrev.toLocaleString("en-IN")}</td>
                        <td>
                          {row.deptRecoveredThisMonth.toLocaleString("en-IN")}
                        </td>
                        <td>{row.deptRecoveredTotal.toLocaleString("en-IN")}</td>
                        <td className="text-center">
                          {row.deptRecoveryPercent}%
                        </td>

                        <td>{row.rfLoanAmount.toLocaleString("en-IN")}</td>
                        <td>{row.rfBeneficiaries.toLocaleString("en-IN")}</td>
                        <td>{row.rfRecoveredPrev.toLocaleString("en-IN")}</td>
                        <td>
                          {row.rfRecoveredThisMonth.toLocaleString("en-IN")}
                        </td>
                        <td>{row.rfRecoveredTotal.toLocaleString("en-IN")}</td>
                        <td className="text-center">
                          {row.rfRecoveryPercent}%
                        </td>
                        <td className="text-center">
                          {row.rfLoanGivenPercent}%
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyReport;
